/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const acceptAgreement = /* GraphQL */ `mutation AcceptAgreement($input: AcceptAgreementInput!) {
  acceptAgreement(input: $input)
}
` as GeneratedMutation<
  APITypes.AcceptAgreementMutationVariables,
  APITypes.AcceptAgreementMutation
>;
export const addBeneficiary = /* GraphQL */ `mutation AddBeneficiary($input: AddBeneficiaryInput!) {
  addBeneficiary(input: $input) {
    gotoUrl
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddBeneficiaryMutationVariables,
  APITypes.AddBeneficiaryMutation
>;
export const addBillToGroup = /* GraphQL */ `mutation AddBillToGroup($addBillInput: AddBillToGroupInput!) {
  addBillToGroup(addBillInput: $addBillInput) {
    bill {
      amount
      createdAt
      createdBy
      currency
      groupId
      id
      name
      owings {
        amount
        avatarUrl
        currency
        firstName
        id
        narwhalId
        username
        __typename
      }
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddBillToGroupMutationVariables,
  APITypes.AddBillToGroupMutation
>;
export const addEmailToPayment = /* GraphQL */ `mutation AddEmailToPayment($input: AddEmailToPaymentInput!) {
  addEmailToPayment(input: $input)
}
` as GeneratedMutation<
  APITypes.AddEmailToPaymentMutationVariables,
  APITypes.AddEmailToPaymentMutation
>;
export const addItemToBasket = /* GraphQL */ `mutation AddItemToBasket($input: BasketInput!) {
  addItemToBasket(input: $input) {
    basket {
      currency
      displayTotal
      id
      items {
        addedAt
        currency
        displayPrice
        name
        price
        quantity
        shortCode
        updatedAt
        variantId
        vatAmount
        __typename
      }
      total
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.AddItemToBasketMutationVariables,
  APITypes.AddItemToBasketMutation
>;
export const checkoutBasket = /* GraphQL */ `mutation CheckoutBasket($input: BasketCheckoutInput!) {
  checkoutBasket(input: $input) {
    gotoUrl
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CheckoutBasketMutationVariables,
  APITypes.CheckoutBasketMutation
>;
export const claimFreeItem = /* GraphQL */ `mutation ClaimFreeItem($claimInput: ClaimFreeItemInput!) {
  claimFreeItem(claimInput: $claimInput) {
    claim {
      claimId
      claimerEmail
      claimerName
      claimerNarwhalId
      createdAt
      image
      isPopped
      merchantName
      merchantNarwhalId
      name
      poppedAt
      shortCode
      variantId
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ClaimFreeItemMutationVariables,
  APITypes.ClaimFreeItemMutation
>;
export const createBeneficiary = /* GraphQL */ `mutation CreateBeneficiary($input: CreateBeneficiaryInput!) {
  createBeneficiary(input: $input) {
    id
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBeneficiaryMutationVariables,
  APITypes.CreateBeneficiaryMutation
>;
export const createCardPayment = /* GraphQL */ `mutation CreateCardPayment($input: CreateCardPaymentInput!) {
  createCardPayment(input: $input) {
    amount
    foreignId
    id
    note
    paymentQrSrc
    paymentUrl
    status
    transferId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCardPaymentMutationVariables,
  APITypes.CreateCardPaymentMutation
>;
export const createCustomerNote = /* GraphQL */ `mutation CreateCustomerNote($input: CustomerNoteInput!) {
  createCustomerNote(input: $input) {
    content
    createdAt
    customerNarwhalId
    id
    summary
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomerNoteMutationVariables,
  APITypes.CreateCustomerNoteMutation
>;
export const createGroup = /* GraphQL */ `mutation CreateGroup($groupInput: CreateGroupInput!) {
  createGroup(groupInput: $groupInput) {
    group {
      bills {
        amount
        createdAt
        createdBy
        currency
        groupId
        id
        name
        owings {
          amount
          avatarUrl
          currency
          firstName
          id
          narwhalId
          username
          __typename
        }
        __typename
      }
      createdAt
      id
      imageUrl
      members {
        avatarUrl
        firstName
        groupCreator
        groupId
        id
        narwhalId
        username
        __typename
      }
      name
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGroupMutationVariables,
  APITypes.CreateGroupMutation
>;
export const createInvoice = /* GraphQL */ `mutation CreateInvoice($input: CreateInvoiceInput!) {
  createInvoice(input: $input) {
    createdAt
    customerNarwhalId
    dueDate
    invoiceNumber
    issueDate
    merchantNarwhalId
    orderItems
    payee {
      accountNumber
      address
      email
      id
      name
      sortCode
      username
      __typename
    }
    payer {
      address
      email
      id
      name
      __typename
    }
    subtotal
    totalAmount
    totalVAT
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateInvoiceMutationVariables,
  APITypes.CreateInvoiceMutation
>;
export const createItem = /* GraphQL */ `mutation CreateItem($item: ItemInput!) {
  createItem(item: $item) {
    item {
      archived
      display
      displayPrice
      image
      name
      price
      quantity
      quantitySold
      questions
      shortCode
      variants {
        display
        name
        quantity
        quantitySold
        variantId
        __typename
      }
      vatRate
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateItemMutationVariables,
  APITypes.CreateItemMutation
>;
export const createLink = /* GraphQL */ `mutation CreateLink($input: LinkInput!) {
  createLink(input: $input) {
    createdAt
    id
    metadata
    narwhalId
    targetUrl
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateLinkMutationVariables,
  APITypes.CreateLinkMutation
>;
export const createPayment = /* GraphQL */ `mutation CreatePayment($input: CreatePaymentInput!) {
  createPayment(input: $input) {
    amount
    foreignId
    id
    note
    paymentQrSrc
    paymentUrl
    status
    transferId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreatePaymentMutationVariables,
  APITypes.CreatePaymentMutation
>;
export const createRequest = /* GraphQL */ `mutation CreateRequest($input: CreateRequestInput!) {
  createRequest(input: $input) {
    request {
      amount
      createdAt
      currency
      id
      narwhalId
      note
      status
      updatedAt
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRequestMutationVariables,
  APITypes.CreateRequestMutation
>;
export const createStripeOnboardingLink = /* GraphQL */ `mutation CreateStripeOnboardingLink {
  createStripeOnboardingLink
}
` as GeneratedMutation<
  APITypes.CreateStripeOnboardingLinkMutationVariables,
  APITypes.CreateStripeOnboardingLinkMutation
>;
export const createStripeSubscription = /* GraphQL */ `mutation CreateStripeSubscription($input: CreateStripeSubscriptionInput!) {
  createStripeSubscription(input: $input) {
    email
    id
    name
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateStripeSubscriptionMutationVariables,
  APITypes.CreateStripeSubscriptionMutation
>;
export const credentials = /* GraphQL */ `mutation Credentials($input: CredentialsInput) {
  credentials(input: $input) {
    credentials
    identityId
    intercomConfig
    isSignupComplete
    narwhalId
    refreshToken
    username
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CredentialsMutationVariables,
  APITypes.CredentialsMutation
>;
export const joinGroup = /* GraphQL */ `mutation JoinGroup($groupInput: JoinGroupInput!) {
  joinGroup(groupInput: $groupInput) {
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.JoinGroupMutationVariables,
  APITypes.JoinGroupMutation
>;
export const login = /* GraphQL */ `mutation Login($input: LoginInput) {
  login(input: $input) {
    canActAsBeneficiary
    credentials
    identityId
    intercomConfig
    isTemporaryPassword
    narwhalId
    refreshToken
    serverTime
    setCookie
    success
    username
    __typename
  }
}
` as GeneratedMutation<APITypes.LoginMutationVariables, APITypes.LoginMutation>;
export const popClaim = /* GraphQL */ `mutation PopClaim($claim: PopClaimInput!) {
  popClaim(claim: $claim) {
    claim {
      claimId
      claimerEmail
      claimerName
      claimerNarwhalId
      createdAt
      image
      isPopped
      merchantName
      merchantNarwhalId
      name
      poppedAt
      shortCode
      variantId
      __typename
    }
    message
    success
    variant {
      display
      name
      quantity
      quantitySold
      variantId
      __typename
    }
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PopClaimMutationVariables,
  APITypes.PopClaimMutation
>;
export const refreshPayment = /* GraphQL */ `mutation RefreshPayment($input: RefreshPaymentInput!) {
  refreshPayment(input: $input) {
    amount
    id
    note
    paymentQrSrc
    paymentUrl
    status
    transferId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.RefreshPaymentMutationVariables,
  APITypes.RefreshPaymentMutation
>;
export const sendTransferToDisplay = /* GraphQL */ `mutation SendTransferToDisplay(
  $sendTransferToDisplayInput: SendTransferToDisplayInput!
) {
  sendTransferToDisplay(
    sendTransferToDisplayInput: $sendTransferToDisplayInput
  ) {
    amount
    authUrl {
      gotoUrl
      gotoUrlQr
      __typename
    }
    currency
    date
    details {
      avatar
      companyPreferences {
        guestCheckout
        __typename
      }
      name
      type
      __typename
    }
    direction
    id
    isAccepted
    isError
    isInitiated
    isSettled
    note
    ownerNarwhalId
    serviceProviderName
    statementReference
    status
    vatAmount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendTransferToDisplayMutationVariables,
  APITypes.SendTransferToDisplayMutation
>;
export const setCompanyBillingActive = /* GraphQL */ `mutation SetCompanyBillingActive {
  setCompanyBillingActive
}
` as GeneratedMutation<
  APITypes.SetCompanyBillingActiveMutationVariables,
  APITypes.SetCompanyBillingActiveMutation
>;
export const setCompanyLogo = /* GraphQL */ `mutation SetCompanyLogo($input: CompanyLogoInput!) {
  setCompanyLogo(input: $input)
}
` as GeneratedMutation<
  APITypes.SetCompanyLogoMutationVariables,
  APITypes.SetCompanyLogoMutation
>;
export const setCompanyPreferences = /* GraphQL */ `mutation SetCompanyPreferences($input: CompanyPreferencesInput!) {
  setCompanyPreferences(input: $input)
}
` as GeneratedMutation<
  APITypes.SetCompanyPreferencesMutationVariables,
  APITypes.SetCompanyPreferencesMutation
>;
export const setMyReferrer = /* GraphQL */ `mutation SetMyReferrer($username: String!) {
  setMyReferrer(username: $username) {
    notFound
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetMyReferrerMutationVariables,
  APITypes.SetMyReferrerMutation
>;
export const setNotificationsEmail = /* GraphQL */ `mutation SetNotificationsEmail($email: String!) {
  setNotificationsEmail(email: $email)
}
` as GeneratedMutation<
  APITypes.SetNotificationsEmailMutationVariables,
  APITypes.SetNotificationsEmailMutation
>;
export const setNotificationsPush = /* GraphQL */ `mutation SetNotificationsPush(
  $setNotificationsPushInput: SetNotificationsPushInput!
) {
  setNotificationsPush(setNotificationsPushInput: $setNotificationsPushInput)
}
` as GeneratedMutation<
  APITypes.SetNotificationsPushMutationVariables,
  APITypes.SetNotificationsPushMutation
>;
export const setPaymentMethod = /* GraphQL */ `mutation SetPaymentMethod($input: SetPaymentMethodInput!) {
  setPaymentMethod(input: $input) {
    amount
    foreignId
    id
    note
    paymentQrSrc
    paymentUrl
    status
    transferId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetPaymentMethodMutationVariables,
  APITypes.SetPaymentMethodMutation
>;
export const setRemitterToAgreement = /* GraphQL */ `mutation SetRemitterToAgreement($input: RemitterAgreementInput!) {
  setRemitterToAgreement(input: $input) {
    agreement {
      id
      __typename
    }
    success
    transfer {
      amount
      authUrl {
        gotoUrl
        gotoUrlQr
        __typename
      }
      currency
      date
      details {
        avatar
        companyPreferences {
          guestCheckout
          __typename
        }
        name
        type
        __typename
      }
      direction
      id
      isAccepted
      isError
      isInitiated
      isSettled
      note
      ownerNarwhalId
      serviceProviderName
      statementReference
      status
      vatAmount
      __typename
    }
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SetRemitterToAgreementMutationVariables,
  APITypes.SetRemitterToAgreementMutation
>;
export const signUpCompany = /* GraphQL */ `mutation SignUpCompany($input: SignUpFieldsInput!) {
  signUpCompany(input: $input) {
    merchantData {
      bankName
      boostText
      canActAsBeneficiary
      companyDescription
      companyName
      companyNumber
      companyRegisteredAddress
      customBoostText
      email
      entityType
      firstName
      isNeedApiClient
      lastName
      logoUrl
      onboardingStatus
      phoneNumber
      redirectName
      redirectUri
      stage
      subdomainPrefix
      supervisor_id
      website
      __typename
    }
    narwhalId
    success
    verifyURL
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SignUpCompanyMutationVariables,
  APITypes.SignUpCompanyMutation
>;
export const signup = /* GraphQL */ `mutation Signup($input: SignupInput) {
  signup(input: $input) {
    canActAsBeneficiary
    credentials
    identityId
    intercomConfig
    isTemporaryPassword
    narwhalId
    refreshToken
    serverTime
    setCookie
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SignupMutationVariables,
  APITypes.SignupMutation
>;
export const updateAnswersToQuestions = /* GraphQL */ `mutation UpdateAnswersToQuestions($updateAnswersInput: UpdateAnswersInput!) {
  updateAnswersToQuestions(updateAnswersInput: $updateAnswersInput)
}
` as GeneratedMutation<
  APITypes.UpdateAnswersToQuestionsMutationVariables,
  APITypes.UpdateAnswersToQuestionsMutation
>;
export const updateBasketItem = /* GraphQL */ `mutation UpdateBasketItem($input: UpdateBasketItemInput!) {
  updateBasketItem(input: $input) {
    basket {
      currency
      displayTotal
      id
      items {
        addedAt
        currency
        displayPrice
        name
        price
        quantity
        shortCode
        updatedAt
        variantId
        vatAmount
        __typename
      }
      total
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBasketItemMutationVariables,
  APITypes.UpdateBasketItemMutation
>;
export const updateCompanyDetails = /* GraphQL */ `mutation UpdateCompanyDetails($input: UpdateCompanyDetailsInput!) {
  updateCompanyDetails(input: $input) {
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCompanyDetailsMutationVariables,
  APITypes.UpdateCompanyDetailsMutation
>;
export const updateCustomerNote = /* GraphQL */ `mutation UpdateCustomerNote($input: UpdateCustomerNoteInput!) {
  updateCustomerNote(input: $input) {
    content
    createdAt
    customerNarwhalId
    id
    summary
    title
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerNoteMutationVariables,
  APITypes.UpdateCustomerNoteMutation
>;
export const updateIndividual = /* GraphQL */ `mutation UpdateIndividual($individual: UpdateIndividualInput!) {
  updateIndividual(individual: $individual) {
    message
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateIndividualMutationVariables,
  APITypes.UpdateIndividualMutation
>;
export const updateInvoice = /* GraphQL */ `mutation UpdateInvoice($id: Int!, $input: CreateInvoiceInput!) {
  updateInvoice(id: $id, input: $input) {
    createdAt
    customerNarwhalId
    dueDate
    invoiceNumber
    issueDate
    merchantNarwhalId
    orderItems
    payee {
      accountNumber
      address
      email
      id
      name
      sortCode
      username
      __typename
    }
    payer {
      address
      email
      id
      name
      __typename
    }
    subtotal
    totalAmount
    totalVAT
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateInvoiceMutationVariables,
  APITypes.UpdateInvoiceMutation
>;
export const updateItem = /* GraphQL */ `mutation UpdateItem($item: UpdateItemInput!) {
  updateItem(item: $item) {
    item {
      archived
      display
      displayPrice
      image
      name
      price
      quantity
      quantitySold
      questions
      shortCode
      variants {
        display
        name
        quantity
        quantitySold
        variantId
        __typename
      }
      vatRate
      __typename
    }
    success
    warnings
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateItemMutationVariables,
  APITypes.UpdateItemMutation
>;
export const updatePayment = /* GraphQL */ `mutation UpdatePayment($input: UpdatePaymentInput!) {
  updatePayment(input: $input)
}
` as GeneratedMutation<
  APITypes.UpdatePaymentMutationVariables,
  APITypes.UpdatePaymentMutation
>;
export const updateTransfer = /* GraphQL */ `mutation UpdateTransfer($updateTransferInput: UpdateTransferInput!) {
  updateTransfer(updateTransferInput: $updateTransferInput) {
    amount
    authUrl {
      gotoUrl
      gotoUrlQr
      __typename
    }
    currency
    date
    details {
      avatar
      companyPreferences {
        guestCheckout
        __typename
      }
      name
      type
      __typename
    }
    direction
    id
    isAccepted
    isError
    isInitiated
    isSettled
    note
    ownerNarwhalId
    serviceProviderName
    statementReference
    status
    vatAmount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTransferMutationVariables,
  APITypes.UpdateTransferMutation
>;
export const updateUsername = /* GraphQL */ `mutation UpdateUsername($input: UpdateUsernameInput!) {
  updateUsername(input: $input) {
    success
    username
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateUsernameMutationVariables,
  APITypes.UpdateUsernameMutation
>;
export const uploadImage = /* GraphQL */ `mutation UploadImage($image: ImageUploadUrlInput!) {
  uploadImage(image: $image) {
    key
    signedUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UploadImageMutationVariables,
  APITypes.UploadImageMutation
>;
export const uploadProfileImage = /* GraphQL */ `mutation UploadProfileImage($image: ImageProfileUploadUrlInput!) {
  uploadProfileImage(image: $image) {
    key
    signedUrl
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UploadProfileImageMutationVariables,
  APITypes.UploadProfileImageMutation
>;
